import { render, staticRenderFns } from "./MasterBatangan.vue?vue&type=template&id=65410f95&scoped=true"
import script from "./MasterBatangan.vue?vue&type=script&lang=js"
export * from "./MasterBatangan.vue?vue&type=script&lang=js"
import style0 from "./MasterBatangan.vue?vue&type=style&index=0&id=65410f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65410f95",
  null
  
)

export default component.exports